import { isNil } from 'lodash';
import { MBIconV2Name } from '@shared/components/image';
import { GenericComponent } from '../../config';
import { FieldOption } from './FieldOption';

export class ReservedIdFieldOption implements FieldOption {
  constructor(
    readonly title: string,
    readonly icon: MBIconV2Name,
    readonly component: Partial<GenericComponent>,
  ) {}

  matchesComponent(
    component: MBAPI.WorkflowTemplate_components,
    _reservedIds: Array<string>,
  ): boolean {
    return this.component.id === component.id && this.component.type === component.type;
  }

  canBeAdded(components: MBAPI.WorkflowTemplate_components[]): boolean {
    return isNil(components.find(c => c.id === this.component.id));
  }
}
